"use client";

import { createContext, useContext } from "react";

/** @type {import('react').Context<boolean>} */
export const PreCheckoutEmbeddedContext = createContext(false);

/**
 * Returns whether personalization UI is rendered inside the mobile pre-checkout drawer.
 * When true, nested Drawer components should render inline without a second overlay.
 * @returns {boolean}
 */
export const usePreCheckoutEmbedded = () => useContext(PreCheckoutEmbeddedContext);
